import Operation from './Operation';

export default function ProjectPointsOntoPlane(props) {
  return (<Operation {...props}>
  ProjectPointsOntoPlane
  </Operation>);
};
